import React from "react";
import { Link } from "react-router-dom";
import { PhoneCall } from "@phosphor-icons/react";

/**
 * FloatingBookButton — fixed-position CTA shown on Calculator, Goal Lab,
 * and Quiz pages so the user is always one tap from a booking.
 *
 * Links to the existing /reserve flow (do NOT change — Leon's Google
 * Calendar + Stripe flow already works through this route).
 */
export default function FloatingBookButton({ testid = "floating-book-btn", label = "Book a call" }) {
  return (
    <Link
      to="/reserve"
      data-testid={testid}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-exodus-gold text-exodus-bg hover:bg-exodus-gold-deep transition-colors px-5 py-3 shadow-[0_8px_24px_rgba(198,161,91,0.35)] text-sm font-medium whitespace-nowrap"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      aria-label={label}
    >
      <PhoneCall size={16} weight="fill" />
      <span className="hidden sm:inline">{label}</span>
    </Link>
  );
}
